module.exports = __webpack_public_path__ + "img/avatar5.cd9da59a.png";